import { useState } from 'react'
import { Button } from './ui/button'
import { Link } from 'react-router'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from './ui/sheet'
import { Menu } from 'lucide-react'

export default function HomeNav() {
  const [open, setOpen] = useState(false)

  return (
    <nav className="border-none backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <a href="/" className="flex items-center gap-2 cursor-pointer">
            <img src="/kanu-logo.png" alt="Kanu Energy Logo" className="h-12" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            <a
              href="#"
              className="font-medium tracking-wide text-foreground/55 hover:text-foreground transition-colors duration-200"
            >
              About
            </a>
            <a
              href="/#features"
              className="font-medium tracking-wide text-foreground/55 hover:text-foreground transition-colors duration-200"
            >
              Features
            </a>
            <a
              href="/#demo"
              className="font-medium tracking-wide text-foreground/55 hover:text-foreground transition-colors duration-200"
            >
              Demo
            </a>
          </div>

          {/* Desktop Buttons */}
          <div className="hidden md:flex items-center gap-5">
            {/* <Button variant="ghost" asChild className="text-[16px] font-medium text-foreground/65 hover:text-[#1D591B] hover:bg-transparent px-0">
              <Link to="/login">Sign In</Link>
            </Button> */}
            <Button asChild className="text-[16px] bg-[#1D591B] text-white hover:bg-[#1D591B]/85 rounded-none px-6 font-semibold text-sm tracking-wide h-10 cursor-pointer">
              <Link to="/waitlist">Join the Waitlist</Link>
            </Button>
          </div>

          {/* Mobile Hamburger */}
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-foreground/5">
                <Menu className="h-5 w-5" />
                <span className="sr-only">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-75 sm:w-100 bg-white border-l border-foreground/8 px-8">
              <SheetHeader className="px-0 pt-2">
                <SheetTitle className="flex items-center">
                  <img src="/kanu-logo.png" alt="Kanu Energy" className="h-9" />
                </SheetTitle>
              </SheetHeader>

              <div className="flex flex-col mt-10 border-t border-foreground/8">
                <a
                  href="#"
                  className="text-base font-medium text-foreground/65 hover:text-foreground transition-colors py-5 border-b border-foreground/8"
                  onClick={() => setOpen(false)}
                >
                  About
                </a>
                <a
                  href="/#features"
                  className="text-base font-medium text-foreground/65 hover:text-foreground transition-colors py-5 border-b border-foreground/8"
                  onClick={() => setOpen(false)}
                >
                  Features
                </a>
                <a
                  href="/#demo"
                  className="text-base font-medium text-foreground/65 hover:text-foreground transition-colors py-5 border-b border-foreground/8"
                  onClick={() => setOpen(false)}
                >
                  Demo
                </a>
              </div>

              <div className="flex flex-col gap-3 mt-8">
                <Button variant="outline" size="lg" className="rounded-none border-foreground/20 font-medium" asChild>
                  {/* <Link to="/login" onClick={() => setOpen(false)}>
                    Sign In
                  </Link> */}
                </Button>
                <Button size="lg" className="rounded-none bg-[#1D591B] hover:bg-[#1D591B]/85 font-semibold" asChild>
                  <Link to="/waitlist" onClick={() => setOpen(false)}>
                    Join the Waitlist
                  </Link>
                </Button>
              </div>
            </SheetContent>
          </Sheet>

        </div>
      </div>
    </nav>
  )
}
